import { PageViewEvent } from 'https://cdn.shopify.com/storefront/standard-events.js';

/** Retain Shopify's native page-view event without loading unused UI components. */
function publishPageView() {
  document.dispatchEvent(new PageViewEvent({
    page: {
      template: document.querySelector('main[data-template]')?.dataset.template || '',
      title: document.title,
      url: window.location.href,
    },
  }));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', publishPageView, { once: true });
} else {
  publishPageView();
}
